import { render, staticRenderFns } from "./Multiselect-Picker.vue?vue&type=template&id=faa84908&"
import script from "./Multiselect-Picker.vue?vue&type=script&lang=js&"
export * from "./Multiselect-Picker.vue?vue&type=script&lang=js&"
import style0 from "./Multiselect-Picker.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports